export default function FoodShowcase() {
  const images = [
    {
      src: 'https://readdy.ai/api/search-image?query=Overhead%20view%20of%20premium%20Turkish%20catering%20meal%20spread%20rice%20meat%20chicken%20vegetables%20salads%20soups%20in%20stainless%20steel%20containers%20professional%20food%20photography%20bright%20lighting&width=1200&height=800&seq=food-gallery-1&orientation=landscape',
      alt: 'Premium Türk mutfağı yemek sunumu',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Professional%20catering%20line%20with%20multiple%20Turkish%20hot%20dishes%20in%20stainless%20steel%20bain%20marie%20trays%20steam%20rising%20bright%20hygienic%20kitchen%20environment%20editorial%20photography&width=1200&height=800&seq=food-gallery-2&orientation=landscape',
      alt: 'Catering hattı sıcak yemek sunumu',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Close-up%20of%20fresh%20Turkish%20salads%20and%20side%20dishes%20in%20professional%20catering%20trays%20colorful%20vegetables%20herbs%20olive%20oil%20premium%20food%20photography&width=1200&height=800&seq=food-gallery-3&orientation=landscape',
      alt: 'Taze salatalar ve mezeler',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-accent-950">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto text-center">
        <div className="reveal mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
            LEZZETLİ YEMEK, DÜZENLİ HİZMET
          </h2>
          <p className="font-body text-background-300 text-base md:text-lg max-w-2xl mx-auto">
            Her gün taze ve hijyenik koşullarda hazırlanan lezzetli menüler.
          </p>
        </div>
        <div className="reveal grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {images.map((image) => (
            <div
              key={image.alt}
              className="rounded-2xl overflow-hidden aspect-[4/3]"
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}